import { useState, useEffect } from "react";
import CrudTable from "@/components/CrudTable";
import { MODULES } from "@/config/modules";
import { useLookups } from "@/hooks/useLookups";
import { api } from "@/lib/api";
import { Trophy, BellRinging } from "@phosphor-icons/react";

export default function Telecalling() {
  const { lists, nameMap } = useLookups();
  const [board, setBoard] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => { api.get("/analytics/leaderboard").then((r) => setBoard(r.data)); }, []);

  const today = new Date().toISOString().slice(0, 10);
  const overdue = rows.filter((l) => l.counselling_booked !== "Yes" && l.next_followup_date && String(l.next_followup_date).slice(0, 10) < today);

  const header = (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
      <div className="lg:col-span-2 rounded-lg bg-white border border-slate-200 p-4">
        <div className="flex items-center gap-2 mb-3">
          <Trophy size={18} weight="fill" className="text-gold" />
          <h3 className="font-heading font-bold text-navy">Telecaller Leaderboard</h3>
        </div>
        <div className="space-y-2">
          {board.length === 0 && <p className="text-sm text-slate">No telecaller activity yet.</p>}
          {board.map((t, i) => (
            <div key={t.employee_id} className="flex items-center gap-3 py-2 border-b border-slate-100 last:border-0">
              <span className={`h-7 w-7 rounded-full flex items-center justify-center text-xs font-bold ${i === 0 ? "bg-gold text-navy" : "bg-slate-100 text-slate"}`}>{i + 1}</span>
              <span className="flex-1 font-medium text-navy text-sm">{t.name}</span>
              <span className="text-xs text-slate w-20 text-right">{t.calls} calls</span>
              <span className="text-xs w-24 text-right"><span className={t.connect_rate >= 60 ? "text-emerald font-semibold" : "text-slate"}>{t.connect_rate}% connect</span></span>
              <span className="text-xs w-24 text-right font-semibold text-navy">{t.bookings} bookings</span>
            </div>
          ))}
        </div>
      </div>
      <div className="rounded-lg bg-white border border-slate-200 p-4">
        <div className="flex items-center gap-2 mb-3">
          <BellRinging size={18} weight="fill" className="text-rose" />
          <h3 className="font-heading font-bold text-navy">Follow-ups Overdue</h3>
        </div>
        {overdue.length === 0 ? (
          <p className="text-sm text-slate">All follow-ups on track 🎉</p>
        ) : (
          <div className="space-y-2 max-h-40 overflow-y-auto">
            {overdue.slice(0, 8).map((l) => (
              <div key={l.id} className="flex items-center justify-between text-sm">
                <span className="text-navy font-medium">{l.lead_name}</span>
                <span className="text-rose text-xs font-semibold">{l.next_followup_date}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div data-testid="telecalling-page">
      <CrudTable resource="leads" config={MODULES.leads} lists={lists} nameMap={nameMap} onData={setRows} extraHeader={header} />
    </div>
  );
}
